"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useRouter } from "next/navigation";

import { logoutUser } from "@/lib/centra/selectionFunctions";
import usePersistedStore from "@/lib/stateManagement/persistedState/persistedStore";
import { CentraJS } from "@frend-digital/centra-js-client";

export default function useLogOut() {
  const queryClient = useQueryClient();
  const customerToken = usePersistedStore((state) => state.token);
  const router = useRouter();

  const logOut = useMutation({
    mutationFn: () => logoutUser(customerToken),

    onError: async (error: Error) => {
      return error;
    },

    onSuccess: async (data) => {
      queryClient.setQueryData(["selection"], data);
      Cookies.remove("token");
      queryClient.invalidateQueries({
        queryKey: ["selection"],
      });
      router.push("/");
    },
    onSettled: () => {
      CentraJS.resume();
    },
  });

  return { logOut };
}
